let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hd2PH")).then(() => parcelRequire('lsYIe'));